import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AddServicesToBillingaccountsWizardEffects } from './effects';
import * as fromAddServicesToBillingaccountsWizard from './reducer';

export function provideAddServicesToBillingaccountsWizardStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(
      fromAddServicesToBillingaccountsWizard.addServicesToBillingaccountsWizardFeatureKey,
      fromAddServicesToBillingaccountsWizard.reducer,
    ),
    provideEffects(AddServicesToBillingaccountsWizardEffects),
  ]);
}
